<template>
  <a-config-provider :locale="zh_CN">
    <div id="app" style="height: 100%">
      <a-button class="btn-drawer" type="primary" v-if="enableTag" @click="showDrawer" shape="circle" icon="tags" size="large"> </a-button>

      <strategy-tag-drawer v-if="visible" :visible="visible" :projectId="projectId" @visible="refreshVisible" />
      <transition name="router-fades" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </a-config-provider>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import { mapGetters } from 'vuex';
import moment from 'moment';
import 'moment/locale/zh-cn';
import Event from '@/utils/event';
import { pathPermission } from '@/utils/utils';
import { routeMap } from '@/utils/globalRouteMap';
import strategyTagDrawer from '@/components/project/strategyTagDrawer';
import store from '@/store';
import { pathHasDrawer } from '@/common/constant';

moment.locale('zh-cn');

export default {
  data() {
    return {
      zh_CN,
      visible: false,
      enableTag: false,
      projectId: 0
    };
  },
  components: {
    strategyTagDrawer
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {
    $route: {
      handler: function(to, from) {
        const { permissions } = this.userInfo || {};
        let hasPermission = pathPermission(permissions, '/drawer');
        if (hasPermission && pathHasDrawer.indexOf(to.path) > -1) {
          if (to.path === '/pdfview') {
            this.enableTag = to.query.projectId ? true : false;
          } else {
            this.enableTag = true;
          }
        } else {
          this.enableTag = false;
        }
        // 如果有设置meta的title,就设置网站标题,否则就设置为默认
        let tmp = to.matched.find(_ => _.meta.title);
        if (tmp) {
          document.title = tmp.meta.title;
        } else {
          document.title = '天池投资管理系统';
        }
        // 完整路径匹配
        this.gaPageViewUpload(to, from);
      },
      immediate: true
    }
  },
  created() {
    Event.$on('setPermission', this.checkPermission);
    document.body.addEventListener('click', this.gaClick, true);
  },
  beforeDestroyed() {
    document.body.removeEventListener('click');
  },
  methods: {
    gaClick(e) {
      // 要判断一下有没有path属性,没有的话用composedPath
      let path = e.path || (e.composedPath && e.composedPath());
      let tmp = path.find(e => {
        return e.dataset && e.dataset.gaId;
      });
      // 如果有gaTd字段就调用ga事件方法,传入target的dataset作为参数
      if (tmp && tmp.dataset.gaId) {
        // 遍历dataSet,拿到以ga开头,不是gaId的参数
        let params = {};
        for (let key in tmp.dataset) {
          if (key.indexOf('ga') > -1 && key !== 'gaId') {
            params[key] = tmp.dataset[key];
          }
        }
        this.$ga.gaUploadCustomEvent(tmp.dataset.gaId, params);
      }
    },
    gaPageViewUpload(to, from) {
      // 路径一致参数不一致,算多次访问
      let params = {
        to: this.pathToTitle(to.path, to.query),
        from: from && from.path ? this.pathToTitle(from.path, from.query) : ''
      };
      this.$ga.gaUploadCustomEvent('tianchi_pv', params);
    },
    pathToTitle(path, query) {
      let res = routeMap[path];
      if (path === '/') {
        let homeMap = {
          1: '-工作进展',
          2: '-观察仓',
          3: '-业务推进情况'
        };
        res += !query.tab ? '-工作进展' : homeMap[+query.tab];
      } else if (path === '/project/detail') {
        let projectDetailMap = {
          1: '-工作进展',
          2: '-项目信息',
          3: '-文档',
          4: '-第三方信息',
          5: '-团队成员信息',
          6: '-portfolio'
        };
        res += !query.tab ? '-工作进展' : projectDetailMap[query.tab];
      }
      return res;
    },
    checkPermission() {
      let path = document.location.pathname;
      if (this.userInfo) {
        let { permissions } = this.userInfo || {};
        let hasPermission = pathPermission(permissions, path);
        if (!hasPermission) {
          this.$router.push('/');
        }
      }
    },
    async showDrawer() {
      await store.dispatch('user/getUserInfo');
      let { permissions } = this.userInfo || {};
      let hasPermission = pathPermission(permissions, '/drawer');
      if (hasPermission) {
        this.projectId = this.$route.path === '/project/detail' ? this.$route.query.id : this.$route.query.projectId;
        this.visible = true;
      } else {
        this.$message.error('暂无权限');
      }
    },
    refreshVisible(val) {
      this.visible = val;
    }
  }
};
</script>
<style lang="less" scoped>
.btn-drawer {
  position: fixed;
  right: 100px;
  bottom: 100px;
  z-index: 100;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.15);
}
/deep/.ant-table,
/deep/.ant-tabs {
  color: rgba(0, 0, 0, 0.85);
}
</style>
<style>
body {
  color: rgba(0, 0, 0, 0.85);
}
</style>
